<template>
  <div class="progress-spinner progress-spinner-active mx-auto text-center">
    <span class="sr-only">Caricamento...</span>
  </div>
</template>

<script>
export default {
  name: 'spinner-row',
  components: {
  },
  data() {
    return {
    };
  },
};
</script>

<style scoped>
  .table{
    width:100%;
  }
</style>



// WEBPACK FOOTER //
// src/components/layout/accessory/Spinner.vue